// client/src/utils/setAuthToken.js (AJUSTADO CRITICAMENTE)
import axios from 'axios';

const setAuthToken = token => {
    // console.log(`[setAuthToken] Called with token: ${token ? 'present' : 'absent'}`);
    if (token) {
        // SETA o token no header SOMENTE se ele for diferente
        if (axios.defaults.headers.common['Authorization'] !== `Bearer ${token}`) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            // console.log('[setAuthToken] Token adicionado ao header do Axios.');
        }
    } else {
        // REMOVE o token do header SOMENTE se ele existir
        if (axios.defaults.headers.common['Authorization']) {
            delete axios.defaults.headers.common['Authorization'];
            // console.log('[setAuthToken] Token removido do header do Axios.');
        }
    }
};

export default setAuthToken;